import React from "react";
import { LinearProgress, ThemeProvider } from "@mui/material";

import "./ProgressBarSnackbar.scss";
import { MUIComponentsTheme } from "../../services/theme-service/ThemeService";

interface ProgressBar {
  percentComplete: number;
}

export default function ProgressBarSnackbar({ percentComplete }: ProgressBar) {
  return (
    <ThemeProvider theme={MUIComponentsTheme}>
      <div className="progress-bar">
        <LinearProgress variant="determinate" value={percentComplete} sx={{ height: 10 }} />
      </div>
    </ThemeProvider>
  );
}
